import {Button, Col, Container, FormGroup, FormText} from "reactstrap";
import {App} from "../../App";
import {Form} from "./Form";
import {Api} from "../../../shared";
import {useState} from "react";

export function Create(props: {reload: () => any})
{
	const [error, setError] = useState<string>();
	const [showError, setShowError] = useState(false);
	const [disabled, setDisabled] = useState(false);
	const [component, setComponent] = useState<Api.Staff.Component.Type>({
		name: "",
		quantity_type: "G",
		surcharge: -1,
		weight: -1,
		out_stock: false,
		templates: [],
	});

	async function onSubmit()
	{
		if(error) {
			setShowError(true);
			return;
		}

		setDisabled(true);

		let res = await Api.Staff.Component.Call.create(component);
		
		if(res.error) {
			setError("Error: " + res.error);
			setShowError(true);
			setDisabled(false);
			return;
		}

		await props.reload();
		App.open(null);
	}

	return (
		<Container>
			<Col><h4>Create Component</h4></Col>
			<Form component={component} onChange={setComponent} onError={setError} showErrors={showError} />
			<Col><FormText color="danger">{error && showError ? error : ``}</FormText></Col>
			<Col><FormGroup>
				<Button onClick={() => App.open(null)}>Close</Button>
				<Button disabled={disabled} onClick={onSubmit}>Submit</Button>
			</FormGroup></Col>
		</Container>
	);
}

